<mat-select
    [attr.cy-select]="ngControl.name"
    [(value)]="value"
    [placeholder]="value"
    panelClass="horus-date-range-fit"
    class="horus-date-range"
    #matSelect
    toggleClassOnValue
    (openedChange)="handleSelection($event)">

    <mat-option disabled class="mat-option-date-range">
        <div class="container-options-date-range">
            <mat-list class="options-default">
                @for (option of dateRangeOptions; track option.description) {
                    <mat-list-item class="date-range-option" [class.date-range-option--selected]="isOptionSelected(option.type)" [attr.data-testid]="option.id" (click)="option.function(); $event.stopPropagation()">{{option.description}}</mat-list-item>
                }
            </mat-list>
            @if (showCustomMonth) {
                <div class="options-datepicker">
                    <mat-calendar
                        appDateRangeAddId
                        [selected]="selected"
                        startView="multi-year"
                        (monthSelected)="setMonthAndYear($event)"
                        panelClass="horus-date-range-calendar">
                    </mat-calendar>
                </div>
            }
        </div>        
    </mat-option>
</mat-select>
